import { Component, ChangeDetectionStrategy, Input, AfterContentInit, OnInit, OnChanges } from '@angular/core';
import { SampleDetails } from '../interfaces/sample-details';
import { TrackingOverviewService } from '../service/tracking-overview.service';

@Component({
    selector: 'app-sample-details',
    template: require('./sample-details.component.html'),
    styles: [require('./sample-details.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SampleDetailsComponent {
    @Input()
    public accessionNo: string;

    @Input()
    public sampleDetails: SampleDetails;

    @Input()
    public isLoadingCompleted: boolean;

    constructor(
        public trackingService: TrackingOverviewService
    ) { }

}